// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer__inner":"Footer_footer__inner__Ujnvm"};